import { getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { getNoImageUrl } from "@client/lib/assets";
import { type AppState, ScreenType } from "@client/types";
import { connect } from "react-redux";
import { setVariantId } from "../../actions";
import { localStateSelector } from "../../selectors";
import Component, { type ActionProps, type MapProps } from "./component";
import { makeItemsSelector } from "./selectors";

type Props = RootContainerProps & {};
const makeMapStateToProps = () => {
  const itemsSelector = makeItemsSelector();

  return (state: AppState, props: Props): MapProps => {
    const localState = localStateSelector(state, props);
    const items = itemsSelector(state, props);

    return {
      ...props,
      isMobile: state.viewport.screen === ScreenType.Mobile,
      currencyCode: localState.currencyCode,
      isVisible: items.length > 1,
      items: items,
      noImageUrl: getNoImageUrl(),
      productVariantId: localState.productVariantId,
      productOptions: localState.cart.productOptions
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: Props): ActionProps => ({
  onChange: (variantId: string) => dispatch(setVariantId(getEntityRef(props), variantId))
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
